// ── V160: 화면 전체 중국어 — L('한국어', …값) ─────────────────────────────────────
// 사장님: "운영 및 전체 다 중국어 버전 적용해줘"
//   화면의 한국어 문구는 L('…')로 감싸 두고(scripts: codemod), 중국어 화면이면 사전(zhDict.json)에서 찾아 바꾼다.
//   사전에 없으면 한국어 그대로 (빠진 문구가 있어도 화면이 깨지지 않게).
//   {0} {1} 자리에 값:  L('{0}건 저장했어요', 3)  →  '3건 저장했어요' / '已保存 3 笔'
//   LH(html): 인쇄용 HTML의 태그 사이 글자를 사전으로 바꾼다
//   언어가 바뀌면 LangProvider가 setTrLang → App이 화면을 다시 그린다 (key)
import ZH from './zhDict.json';
import { UI_ZH } from './ui';
import { fmtMoney, moneyUnit } from '../storeLocale';

const LS_KEY = 'semfit_lang';
let cur = 'ko';
try {
  const v = localStorage.getItem(LS_KEY);
  if (v === 'zh') cur = 'zh';
  else if (!v) {
    const nav = typeof navigator !== 'undefined' ? ((navigator.languages && navigator.languages[0]) || navigator.language || '') : '';
    if (/^zh/i.test(nav)) cur = 'zh';
  }
} catch (e) { /* 저장소를 못 쓰면 한국어 */ }

export const setTrLang = (l) => { cur = l === 'zh' ? 'zh' : 'ko'; };
export const trLang = () => cur;

// 매장 통화 — 중국 매장은 ¥ (LangProvider가 매장 국가를 알려 줌)
let country = null;
export const setTrCountry = (c) => { if (c) country = c; };
export const trCountry = () => country;
/** 금액: 한국 매장 '12,000원' · 중국 매장 '¥12.50' */
export const M = (n) => (country ? fmtMoney(n, country) : fmtMoney(n));
/** 통화 단위만: '원' / '¥' */
export const MU = () => (country ? moneyUnit(country) : moneyUnit());
/** 'YYYY-MM' → '2026년 10월' / '2026年10月' */
export function ym(m) {
  const [y, mo] = String(m || '').split('-');
  if (!mo) return String(m || '');
  return cur === 'zh' ? `${y}年${Number(mo)}月` : `${y}년 ${mo}월`;
}
/** 'YYYY-MM' → '10월' / '10月' */
export function mo(m) {
  const v = String(m || '').slice(5, 7);
  return cur === 'zh' ? `${Number(v)}月` : `${v}월`;
}

const norm = (s) => String(s).replace(/\s+/g, ' ').trim();
/** 사전에서 중국어 찾기 (없으면 null) */
export function zhLookup(ko) {
  if (typeof ko !== 'string' || !ko) return null;
  return ZH[ko] || UI_ZH[ko] || ZH[norm(ko)] || UI_ZH[norm(ko)] || null;
}
const fill = (s, args) => (args.length
  ? String(s).replace(/\{(\d+)\}/g, (m, i) => { const v = args[Number(i)]; return v == null ? '' : String(v); })
  : s);

export function L(ko, ...args) {
  if (cur !== 'zh') return fill(ko, args);
  return fill(zhLookup(ko) || ko, args);
}

/** 값(데이터) 그대로 보여줄 때 — 사전에 있는 고정 문구면 바꾸고, 아니면 그대로 */
export function Lv(v) {
  if (cur !== 'zh' || typeof v !== 'string') return v;
  return zhLookup(v) || v;
}

/** 인쇄용 HTML — 태그 사이 글자가 사전에 있으면 바꾼다 */
export function LH(html) {
  if (cur !== 'zh' || typeof html !== 'string') return html;
  return html
    .replace(/>([^<>]*[가-힣][^<>]*)</g, (m, text) => {
      const t = norm(text);
      const z = zhLookup(t);
      return z ? '>' + text.replace(text.trim(), z) + '<' : m;
    })
    .replace(/<html lang="ko"/, '<html lang="zh"');
}
